module.exports = __webpack_public_path__ + "static/media/tips-gap.37c0738e.png";